import { AbstractEvent } from '@/models/abstractEvent';
import { IPregameDataAPI } from '@/types/event/pregame';

export class PregameItem extends AbstractEvent {
    public btsOpenPriceNo: string | null;
    public btsOpenPriceYes: string | null;
    public cornersGoalOpenPriceOver: string | null;
    public cornersGoalOpenPriceUnder: string | null;
    public cornersHdpOpenPriceAway: string | null;
    public cornersHdpOpenPriceHome: string | null;
    public dcOpenPrice12: string | null;
    public dcOpenPrice1x: string | null;
    public dcOpenPriceX2: string | null;
    public goalAwayOpenPriceOver: string | null;
    public goalAwayOpenPriceUnder: string | null;
    public goalHomeOpenPriceOver: string | null;
    public goalHomeOpenPriceUnder: string | null;
    public goalOpenPriceOver: string;
    public goalOpenPriceUnder: string;
    public hdpOpenPriceAway: string;
    public hdpOpenPriceHome: string;
    public mlOpenPriceAway: string | null;
    public mlOpenPriceHome: string | null;
    public oneXTwoOpenPriceAway: string;
    public oneXTwoOpenPriceDraw: string;
    public oneXTwoOpenPriceHome: string;
    public spreadOpenPriceAway: string | null;
    public spreadOpenPriceHome: string | null;

    constructor(data: IPregameDataAPI) {
        super(data);

        this.oneXTwoOpenPriceAway = data['1x2_open_price_away'] ?? '';
        this.oneXTwoOpenPriceDraw = data['1x2_open_price_draw'] ?? '';
        this.oneXTwoOpenPriceHome = data['1x2_open_price_home'] ?? '';
        this.btsOpenPriceNo = data.bts_open_price_no ?? null;
        this.btsOpenPriceYes = data.bts_open_price_yes ?? null;
        this.goalOpenPriceOver = data.goal_open_price_over ?? '';
        this.goalOpenPriceUnder = data.goal_open_price_under ?? '';
        this.goalHomeOpenPriceOver = data.goal_home_open_price_over ?? null;
        this.goalHomeOpenPriceUnder = data.goal_home_open_price_under ?? null;
        this.goalAwayOpenPriceOver = data.goal_away_open_price_over ?? null;
        this.goalAwayOpenPriceUnder = data.goal_away_open_price_under ?? null;
        this.hdpOpenPriceAway = data.hdp_open_price_away ?? '';
        this.hdpOpenPriceHome = data.hdp_open_price_home ?? '';
        this.mlOpenPriceHome = data.ml_open_price_home ?? null;
        this.mlOpenPriceAway = data.ml_open_price_away ?? null;
        this.spreadOpenPriceHome = data.spread_open_price_home ?? null;
        this.spreadOpenPriceAway = data.spread_open_price_away ?? null;
        this.dcOpenPrice1x = data.dc_open_price_1x ?? null;
        this.dcOpenPrice12 = data.dc_open_price_12 ?? null;
        this.dcOpenPriceX2 = data.dc_open_price_x2 ?? null;
        this.cornersGoalOpenPriceOver = data.corners_goal_open_price_over ?? null;
        this.cornersGoalOpenPriceUnder = data.corners_goal_open_price_under ?? null;
        this.cornersHdpOpenPriceHome = data.corners_hdp_open_price_home ?? null;
        this.cornersHdpOpenPriceAway = data.corners_hdp_open_price_away ?? null;
        this.dnbOpenPriceHome = data.dnb_open_price_home ?? null;
        this.dnbOpenPriceAway = data.dnb_open_price_away ?? null;
    }
}
